export const GET_LIST_REQUEST = 'GET_LIST_REQUEST';
export const GET_LIST_SUCCESS = 'GET_LIST_SUCCESS';
export const GET_LIST_ERROR = 'GET_LIST_ERROR';

export const fetchList = (key, path, page=0, limit=50, order, query) => {
    return {
        type: 'CALL_API',
        types: [GET_LIST_REQUEST, GET_LIST_SUCCESS, GET_LIST_ERROR],
        path: path,
        payload: {
            key,
            params: {
                page,
                limit,
                order,
                query,
            }
        }
    };
}


// WEBPACK FOOTER //
// ./src/actions/lists.js